import i18next from 'i18next';
import moment from 'moment';
import 'moment/locale/es';
import { DEFAULT_LANGUAGE } from './language';

const applyLocale = (language: string): void => {
    moment.locale(language);
};

export const initMomentLocale = (): void => {
    applyLocale(i18next.language || DEFAULT_LANGUAGE);
    i18next.on('languageChanged', applyLocale);
};
